/*
 * @Description: 实时定位驾驶舱 — A3「全员最新位置」本地 mock 数据
 *   仅在 mock 开关开启（?mockCockpit=1）时使用，用于后端接口未就绪时本地验证地图效果。
 *   坐标集中在深圳南山一带，其中部分点位故意贴近以验证聚合（MarkerCluster）。
 */
import { RealtimeLocationsData } from '../types/cockpit.types'

export const MOCK_REALTIME_LOCATIONS: RealtimeLocationsData = {
  total: 10,
  onlineCnt: 7,
  offlineCnt: 3,
  items: [
    {
      userId: 'mock-u1',
      name: '徐兴泽',
      avatar: '',
      online: true,
      location: '113.9412,22.5470',
      locateTime: 1780907268090,
      address: '深圳市南山区科技园南区',
      locationState: 'moving',
      locationStateLabel: '移动中',
      sleepState: 'active',
      battery: 80
    },
    {
      userId: 'mock-u2',
      name: '张三',
      avatar: '',
      online: true,
      location: '113.9430,22.5482',
      locateTime: 1780907190000,
      address: '深圳市南山区高新南一道',
      locationState: 'staying',
      locationStateLabel: '停留中',
      sleepState: 'active',
      battery: 65
    },
    {
      userId: 'mock-u3',
      name: '李四',
      avatar: '',
      online: true,
      location: '113.9435,22.5485',
      locateTime: 1780907100000,
      address: '深圳市南山区高新南一道',
      locationState: 'moving',
      locationStateLabel: '移动中',
      sleepState: 'active',
      battery: 42
    },
    {
      userId: 'mock-u4',
      name: '王五',
      avatar: '',
      online: true,
      location: '113.9521,22.5391',
      locateTime: 1780906900000,
      address: '深圳市南山区深南大道',
      locationState: 'staying',
      locationStateLabel: '停留中',
      sleepState: 'active',
      battery: 90
    },
    {
      userId: 'mock-u5',
      name: '赵六',
      avatar: '',
      online: true,
      location: '113.9602,22.5333',
      locateTime: 1780906800000,
      address: '深圳市南山区滨海大道',
      locationState: 'moving',
      locationStateLabel: '移动中',
      sleepState: 'active',
      battery: 55
    },
    {
      userId: 'mock-u6',
      name: '孙七',
      avatar: '',
      online: true,
      location: '113.9288,22.5510',
      locateTime: 1780906700000,
      address: '深圳市南山区沙河西路',
      locationState: 'staying',
      locationStateLabel: '停留中',
      sleepState: 'active',
      battery: 30
    },
    {
      userId: 'mock-u7',
      name: '周八',
      avatar: '',
      online: true,
      location: '113.9295,22.5515',
      locateTime: 1780906600000,
      address: '深圳市南山区沙河西路',
      locationState: 'moving',
      locationStateLabel: '移动中',
      sleepState: 'active',
      battery: 73
    },
    {
      userId: 'mock-u8',
      name: '吴九',
      avatar: '',
      online: false,
      location: '113.9710,22.5280',
      locateTime: 1780880000000,
      address: '深圳市福田区车公庙',
      locationState: 'staying',
      locationStateLabel: '停留中',
      sleepState: 'sleep',
      battery: 18
    },
    {
      userId: 'mock-u9',
      name: '郑十',
      avatar: '',
      online: false,
      location: '113.9180,22.5600',
      locateTime: 1780875000000,
      address: '深圳市南山区西丽',
      locationState: 'staying',
      locationStateLabel: '停留中',
      sleepState: 'sleep',
      battery: 12
    },
    {
      userId: 'mock-u10',
      name: '钱十一',
      avatar: '',
      online: false,
      location: '113.9805,22.5210',
      locateTime: 1780870000000,
      address: '深圳市福田区香蜜湖',
      locationState: 'staying',
      locationStateLabel: '停留中',
      sleepState: 'sleep',
      battery: 5
    }
  ]
}
